/**
 * @flow
 * @relayHash d74af6b1b9d3521ef1a32f6b8aca186a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PersonAddInput = {
  personType: string,
  firstName: string,
  lastName?: ?string,
  birthdayAt?: ?string,
  shortDescription?: ?string,
  description: string,
  descriptionHtml: string,
  smallAvatar?: ?string,
  verticalImage?: ?string,
  clientMutationId?: ?string,
};
export type PersonAddMutationVariables = {|
  input: PersonAddInput
|};
export type PersonAddMutationResponse = {|
  +PersonAdd: ?{|
    +personEdge: ?{|
      +node: ?{|
        +id: string
      |}
    |}
  |}
|};
export type PersonAddMutation = {|
  variables: PersonAddMutationVariables,
  response: PersonAddMutationResponse,
|};
*/


/*
mutation PersonAddMutation(
  $input: PersonAddInput!
) {
  PersonAdd(input: $input) {
    personEdge {
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "PersonAddInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "PersonAdd",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "PersonAddInput!"
      }
    ],
    "concreteType": "PersonAddPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "personEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "PersonEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Person",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "PersonAddMutation",
  "id": null,
  "text": "mutation PersonAddMutation(\n  $input: PersonAddInput!\n) {\n  PersonAdd(input: $input) {\n    personEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "PersonAddMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "PersonAddMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fcdec750c7b7213f160f26526d617dc3';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/PersonAddMutation.graphql.js